import EmployeeEmptyState from '@web/users/EmptyStates/EmployeeEmptyState/EmployeeEmptyState';

export default {
  ReactComponent: EmployeeEmptyState,
};
